var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasAnnouncement && !_vm.hidden),expression:"hasAnnouncement && !hidden"}],staticClass:"publication has-background-info has-text-white no-print"},[_c('div',{staticClass:"section is-info"},[_c('button',{staticClass:"delete",on:{"click":_vm.hide}}),_vm._v(" "),_c('div',{ref:"content"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }